function state() {
  return {
    variables: {},
  };
}

export default state;
